import React from 'react';

const IconBulletList = ({ title, items }) => {
  return (
    <div className="icon-bullet-list">
      {title && <p className="icon-bullet-title">{title}</p>}
      <ul>
        {items.map(item => (
          <li key={item.label}>
            <span className="icon-chip" aria-hidden="true">
              {item.icon}
            </span>
            <div>
              <p className="icon-item-label">{item.label}</p>
              {item.description && (
                <p className="icon-item-description">{item.description}</p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default IconBulletList;
